export const RingtoneConfig = [
    {
        id: 0,
        isSelected: true,
        name: 'Default',
        src: '/audio/ringtones/Default.mp3'
    },
    {
        id: 1,
        isSelected: false,
        name: 'Coolidge',
        src: '/audio/ringtones/Coolidge.mp3'
    },
    {
        id: 2,
        isSelected: false,
        name: 'Hayes',
        src: '/audio/ringtones/Hayes.mp3'
    },
    {
        id: 3,
        isSelected: false,
        name: 'Pierce',
        src: '/audio/ringtones/Pierce.mp3'
    },
    {
        id: 4,
        isSelected: false,
        name: 'Taft',
        src: '/audio/ringtones/Taft.mp3'
    },
    {
        id: 5,
        isSelected: false,
        name: 'Whig',
        src: '/audio/ringtones/Whig.mp3'
    },
    {
        id: 6,
        isSelected: false,
        name: 'Wiseburen',
        src: '/audio/ringtones/Wiseburen.mp3'
    },
    {
        id: 7,
        isSelected: false,
        name: 'Phone',
        src: '/audio/ringtones/Phone.mp3'
    }
]

export const ActiveCallRingtone = {
    src: '/audio/beep.mp3'
}
